export const mapFileType = (contentType: string): string => {
  switch (contentType.toLowerCase()) {
    case 'jpg':
    case 'jpeg':
    case 'tiff':
    case 'webp':
    case 'raw':
    case 'png':
    case 'heic':
      // falls through
      return 'zdjęcie';
    case 'mov':
    case 'avi':
    case 'wmv':
    case 'avchd':
    case 'flv':
    case 'quicktime':
    case 'x-msvideo':
    case 'x-ms-wmv':
    case 'webm':
    case 'ogg':
    case 'mp4':
      // falls through
      return 'wideo';
    case 'text':
      return 'tekst';
    case 'pdf':
      return 'pdf';
    case 'zip':
      return 'zip';
    default:
      return 'nieznany';
  }
};
